import React, {useEffect, useRef, useState} from 'react';
import {Box, Button, CssVarsProvider, Sheet} from '@mui/joy';
import Demo from '../components/Demo';
import Profile from '../components/Profile';
import {ProjectRepository} from "../repository/ProjectRepository";
import {SummaryModel} from "../model/summary";
import Education from "../components/Education";
import {EducationModel} from "../model/education";
import {ExperienceModel} from "../model/experience";
import {ProjectModel} from "../model/project";
import {SkillModel} from "../model/skill";
import {ServiceModel} from "../model/service";
import Loading from "./Loading";
import LoadingPage from "./Loading";
import TimeOutPage from './TimeOut';
import Footer from "../components/Footer";


function HomePage() {
    const repo = new ProjectRepository()
    const [resumeURL, setResumeURL] = useState<string>('');
    const [profileLight, setProfileLight] = useState<string>('');
    const [profileDark, setProfileDark] = useState<string>('');

    const [summary, setSummary] = useState<SummaryModel>(new SummaryModel());
    const [education, setEducation] = useState<Array<EducationModel>>([]);
    const [experience, setExperience] = useState<Array<ExperienceModel>>([]);
    const [project, setProject] = useState<Array<ProjectModel>>([]);
    const [skill, setSkill] = useState<Array<SkillModel>>([]);
    const [service, setService] = useState<Array<ServiceModel>>([]);
    const [error, setError] = useState<boolean>(false);


    const resumeRef = useRef(null)
    useEffect(() => {
        repo.getResumeURL().then(value => {
            if (value.length > 0) {
                setResumeURL(value);
            }
        }).catch(reason => setError(true));
        repo.getSummary().then(value => {
            if (value.profile.length > 0) {
                setSummary(value);
            }
        }).catch(reason => setError(true));
        repo.getAllProject().then(value => {
            if (value.length > 0) {
                setProject(value);
            }
        }).catch(reason => setError(true));
        repo.getAllSkill().then(value => {
            if (value.length > 0) {
                setSkill(value);
            }
        }).catch(reason => setError(true));
        repo.getAllEducation().then(value => {
            if (value.length > 0) {
                setEducation(value);
            }
        }).catch(reason => setError(true));
        repo.getAllExperience().then(value => {
            if (value.length > 0) {
                setExperience(value);
            }
        }).catch(reason => setError(true));
        repo.getAllService().then(value => {
            if (value.length > 0) {
                setService(value);
            }
        }).catch(reason => setError(true));
        repo.getProfileDarkURL().then(value => {
            if (value.length > 0) {
                setProfileDark(value);
            }
        }).catch(reason => setError(true));
        repo.getProfileLightURL().then(value => {
            if (value.length > 0) {
                setProfileLight(value);
            }
        }).catch(reason => setError(true));
    }, [])
    return (
        <Box>
            <Box paddingTop={2} paddingX={{xs: 2, md: 6,}} sx={{bgcolor: 'background.surface'}}>
                {!(summary.profile.length > 0) && (
                    <LoadingPage/>
                )}
                {(summary.profile.length > 0 && error) && (
                    <TimeOutPage/>
                )}
                {(summary.profile.length > 0 && !error) && (
                    <Sheet>
                        <Profile summary={summary} resumeURL={resumeURL} profileLight={profileLight}
                                 profileDark={profileDark}/>
                        <Demo
                            education={education}
                            experience={experience}
                            skill={skill}
                            service={service}
                        />
                    </Sheet>
                )}
            </Box>
        </Box>
    );
}

export default HomePage;
